import { DEFAULT_ERROR_MESSAGE } from "@constants";
import { TFunction } from "i18next";
import { APIErrorCodes, ErrorResponse, QueryError } from "kz-ui-sdk";

export const resolveAuthResponseError = (error: QueryError<ErrorResponse>, t: TFunction) => {
  if (error?.data?.error?.message === "request rate limited.") {
    const retryAfter = +error?.data?.error?.errors?.["rateLimit"] - +error?.data?.error?.errors?.["diff"];
    if (retryAfter !== null) {
      const minutes = Math.floor(retryAfter / 60);
      const seconds = retryAfter % 60;
      return t(`please wait {{minutes}} and {{seconds}} before trying again`, {
        minutes,
        seconds,
      });
    }
    return t(DEFAULT_ERROR_MESSAGE);
  }

  // Map register error message
  switch (error?.data?.error?.message) {
    case APIErrorCodes.Auth.AccountSuspended:
    case APIErrorCodes.Auth.AccountClosed:
    case APIErrorCodes.Auth.AccountFrozen:
      return t("Request failed, please contact customer service.");
    case APIErrorCodes.Auth.CredentialsTempLocked:
    case APIErrorCodes.Auth.CredentialsTempBlocked: {
      const remainingTime = error?.data?.error?.errors?.remaining as unknown as number;
      const minutes = Math.floor(remainingTime / 60);
      const seconds = remainingTime % 60;

      return t("try again in {{minutes}} and {{seconds}}.", { minutes, seconds });
    }
    default:
      return t(error?.data?.error?.message ?? DEFAULT_ERROR_MESSAGE);
  }
};
